// alterado - revisado

import React from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    GridContainer,
    GridItem1,
    GridItem3,
    GridItem3xs4,
    GridItem6,
    GridItem6xs7,
    GridItem6xs12,
    GridItem7,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    CardGridEntradaDados,
    CardGridDivHeaderEntradaDados,
    CardGridDivEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    TextValidatorText,
    TextValidatorNumber,
    TextValidatorAltura,
    TextValidatorTextMultiline,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    PanelRadioGroup
} from '../../../business-components/RadioGroup/RadioGroup'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    IconButtonHelp,
} from '../../../business-components/IconButton/IconButton'

import {
    pesquisaFamiliar,
} from '../cadastro-form/CadastroServiceFamiliares'

import {
    pesquisaDescricaoList,
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoClassificacaoImcList from '../../../business-rules/List/tipoClassificacaoImcList'

import simNaoList from '../../../business-rules/List/simNaoList'

import tipoFumoList from '../../../business-rules/List/tipoFumoList'

import tipoUtilizacaoMotoList from '../../../business-rules/List/tipoUtilizacaoMotoList'

import RiscosFormEsporteHobbyRisco from './RiscosFormEsporteHobbyRisco'

import RiscosFormCondicaoSaude from './RiscosFormCondicaoSaude'

import RiscosFormHistoricoSaudeFamiliares from './RiscosFormHistoricoSaudeFamiliares'

import {
    inicializaHistoricoSaudeRiscos,
    processaValoresDefaultIniciaisHistoricoSaudeRiscos,
    processaAlteracaoHistoricoSaudeRiscosPeso,
    processaAlteracaoHistoricoSaudeRiscosAltura,
    calculaCorDestaqueHistoricoSaudeRiscosTipoClassificacaoImc,
    processaAlteracaoHistoricoSaudeRiscosFumante,
    processaAlteracaoHistoricoSaudeRiscosTipoFumo,
    processaAlteracaoHistoricoSaudeRiscosUtilizaMoto,
} from './RiscosServiceHistoricoSaudeRiscos'

const RiscosFormHistoricoSaudeRiscos = ({ values, handleChange, handleSubmitAutomatico }) => {

    let nomeFamiliar = ''
    let parentescoFamiliar = ''

    inicializaHistoricoSaudeRiscos(values)

    return (
        <>
            <PanelRadioGroup
                name="familiarHistoricoSaudeRiscos"
                value={Number.parseInt(values.familiarHistoricoSaudeRiscos) || ''}
                onChange={(e) => {
                    handleChange(e)
                    handleSubmitAutomatico(values)
                }}
                list={familiaresList(values)}
            />
               
            <FieldArray name="historicoSaudeRiscos">
                {(arrayHelpers) => (
                    <DivForm>
                        <GridContainer>
                            {values.historicoSaudeRiscos?.map((item, ind) => {
                                nomeFamiliar = pesquisaDescricaoList(familiaresList(values), item.familiar)

                                parentescoFamiliar = pesquisaFamiliar(values.familiares, item.familiar).parentescoFamiliar
                                
                                processaValoresDefaultIniciaisHistoricoSaudeRiscos(values, item, parentescoFamiliar)

                                return item.familiar === Number.parseInt(values.familiarHistoricoSaudeRiscos)  ? (
                                    <GridContainer
                                        key={ind}
                                    >
                                        <GridItem6xs12>
                                            <CardGridEntradaDados>
                                                <CardGridDivHeaderEntradaDados>
                                                    <CardGridDivEntradaDados>
                                                        {LABEL.historicoSaudeRiscos + " " + nomeFamiliar}
                                                    </CardGridDivEntradaDados>
                                                </CardGridDivHeaderEntradaDados>

                                                <CardGridDivBodyEntradaDados>
                                                    <GridContainer>
                                                        <GridItem3>
                                                            <TextValidatorNumber
                                                                name={`historicoSaudeRiscos[${ind}].peso`}
                                                                label={LABEL.peso}
                                                                value={item.peso || ''}
                                                                onChange={handleChange}
                                                                numMin={NUMMIN.peso}
                                                                numMax={NUMMAX.peso}
                                                                onBlur={processaAlteracaoHistoricoSaudeRiscosPeso(item)}
                                                            />
                                                        </GridItem3>
                                                        <GridItem3>
                                                            <TextValidatorAltura
                                                                name={`historicoSaudeRiscos[${ind}].altura`}
                                                                label={LABEL.altura}
                                                                value={item.altura || ''}
                                                                onChange={handleChange}
                                                                onBlur={processaAlteracaoHistoricoSaudeRiscosAltura(item)}
                                                            />
                                                        </GridItem3>
                                                    </GridContainer>

                                                    <GridContainer>
                                                        <GridItem3>
                                                            <TextValidatorNumber
                                                                name={`historicoSaudeRiscos[${ind}].imc`}
                                                                label={LABEL.imc}
                                                                value={item.imc || ''}
                                                                onChange={handleChange}
                                                                numMin={NUMMIN.imc}
                                                                numMax={NUMMAX.imc}
                                                                disabled={true}
                                                            />
                                                        </GridItem3>
                                                        <GridItem6>
                                                            <TextFieldTextSelect
                                                                name={`historicoSaudeRiscos[${ind}].tipoClassificacaoImc`}
                                                                label={LABEL.tipoClassificacaoImc}
                                                                value={item.tipoClassificacaoImc || ''}
                                                                onChange={handleChange}
                                                                list={tipoClassificacaoImcList}
                                                                disabled={true}
                                                                corDestaque={calculaCorDestaqueHistoricoSaudeRiscosTipoClassificacaoImc(item.tipoClassificacaoImc)}
                                                            />
                                                        </GridItem6>
                                                    </GridContainer>

                                                    <CardGridDividerElementos/>

                                                    <GridContainer>
                                                        <GridItem3>
                                                            <TextFieldTextSelect
                                                                name={`historicoSaudeRiscos[${ind}].fumante`}
                                                                label={LABEL.fumante}
                                                                value={item.fumante || ''}
                                                                onChange={handleChange}
                                                                list={simNaoList}
                                                                onBlur={processaAlteracaoHistoricoSaudeRiscosFumante(item)}
                                                            />
                                                        </GridItem3>
                                                        <GridItem3xs4
                                                            style={{
                                                                display:
                                                                    item.fumante === "S" 
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <TextFieldTextSelect
                                                                name={`historicoSaudeRiscos[${ind}].tipoFumo`}
                                                                label={LABEL.tipoFumo}
                                                                value={item.tipoFumo || ''}
                                                                onChange={handleChange}
                                                                list={tipoFumoList}
                                                                onBlur={processaAlteracaoHistoricoSaudeRiscosTipoFumo(item)}
                                                            />
                                                        </GridItem3xs4>
                                                        <GridItem3
                                                            style={{
                                                                display:
                                                                    item.fumante === "S" 
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <TextValidatorNumber
                                                                name={`historicoSaudeRiscos[${ind}].qtdeFumoSemanal`}
                                                                label={LABEL.qtdeFumoSemanal}
                                                                value={item.qtdeFumoSemanal || ''}
                                                                onChange={handleChange}
                                                                numMin={NUMMIN.qtdeFumoSemanal}
                                                                numMax={NUMMAX.qtdeFumoSemanal}
                                                            />
                                                        </GridItem3>
                                                    </GridContainer>

                                                    {item.tipoFumo === HARDCODE.idTipoFumoOutros
                                                        ?
                                                            <GridContainer>
                                                                <GridItem3 />

                                                                <GridItem6xs7>
                                                                    <TextValidatorText
                                                                        name={`historicoSaudeRiscos[${ind}].tipoFumoOutros`}
                                                                        label={LABEL.tipoFumoOutros}
                                                                        value={item.tipoFumoOutros || ''}
                                                                        onChange={handleChange}
                                                                        tamMax={TAMMAX.tipoFumoOutros}
                                                                    />
                                                                </GridItem6xs7>
                                                            </GridContainer>
                                                        :
                                                            ''
                                                    }

                                                    <GridContainer>
                                                        <GridItem3>
                                                            <TextFieldTextSelect
                                                                name={`historicoSaudeRiscos[${ind}].utilizaMoto`}
                                                                label={LABEL.utilizaMoto}
                                                                value={item.utilizaMoto || ''}
                                                                onChange={handleChange}
                                                                list={simNaoList}
                                                                onBlur={processaAlteracaoHistoricoSaudeRiscosUtilizaMoto(item)}
                                                            />
                                                        </GridItem3>
                                                        <GridItem6xs7
                                                            style={{
                                                                display:
                                                                    item.utilizaMoto === "S" 
                                                                        ? "block"
                                                                        : "none"
                                                            }}
                                                        >
                                                            <TextFieldTextSelect
                                                                name={`historicoSaudeRiscos[${ind}].tipoUtilizacaoMoto`}
                                                                label={LABEL.tipoUtilizacaoMoto}
                                                                value={item.tipoUtilizacaoMoto || ''}
                                                                onChange={handleChange}
                                                                list={tipoUtilizacaoMotoList}
                                                            />
                                                        </GridItem6xs7>
                                                    </GridContainer>

                                                    <CardGridDividerElementos/>

                                                    <RiscosFormEsporteHobbyRisco
                                                        familiar={item.familiar}
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />
                                                    
                                                    <CardGridDividerElementos/>

                                                    <RiscosFormCondicaoSaude
                                                        familiar={item.familiar}
                                                        values={values}
                                                        handleChange={handleChange}
                                                    />
                                                    
                                                    {parentescoFamiliar === HARDCODE.idParentescoEnteadao
                                                        ?
                                                            <GridContainer>
                                                                <GridItem1 />

                                                                <GridItem7>
                                                                    <CheckboxPadrao
                                                                        name={`historicoSaudeRiscos[${ind}].informarHistoricoSaudeFamiliaresEnteadao`}
                                                                        label={LABEL.informarHistoricoSaudeFamiliaresEnteadao + " " + nomeFamiliar}
                                                                        checked={item.informarHistoricoSaudeFamiliaresEnteadao}
                                                                        onChange={handleChange}
                                                                    />
                                                                </GridItem7>

                                                                <GridItem3 />

                                                                <GridItem1>
                                                                    <IconButtonHelp
                                                                        helpTitle={LABEL.informarHistoricoSaudeFamiliaresEnteadao}
                                                                        helpText={HELPTEXT.informarHistoricoSaudeFamiliaresEnteadao}
                                                                    />
                                                                </GridItem1>
                                                            </GridContainer>
                                                        :
                                                            ''
                                                    }

                                                    <CardGridDividerElementos/>

                                                    <GridContainer>
                                                        <GridItem12>
                                                            <TextValidatorTextMultiline
                                                                name={`historicoSaudeRiscos[${ind}].observacao`}
                                                                label={LABEL.observacao}
                                                                value={item.observacao || ''}
                                                                onChange={handleChange}
                                                                tamMax={TAMMAX.observacao}
                                                            />
                                                        </GridItem12>
                                                    </GridContainer>
                                                </CardGridDivBodyEntradaDados>
                                            </CardGridEntradaDados>
                                        </GridItem6xs12>

                                        {
                                            (
                                                parentescoFamiliar !== HARDCODE.idParentescoFilhao &&
                                                parentescoFamiliar !== HARDCODE.idParentescoEnteadao
                                             ) ||
                                            item.informarHistoricoSaudeFamiliaresEnteadao
                                                ?
                                                    <GridItem6xs12>
                                                        <RiscosFormHistoricoSaudeFamiliares
                                                            familiar={item.familiar}
                                                            values={values}
                                                            handleChange={handleChange}
                                                        />
                                                    </GridItem6xs12>
                                                :
                                                    ''
                                        }
                                    </GridContainer>
                                )
                                :
                                (
                                ''
                                )}
                            )}
                        </GridContainer>
                    </DivForm>
                )}
            </FieldArray>
        </>
    )
}

export default RiscosFormHistoricoSaudeRiscos